import script from "./StudentJenphoneMailItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentJenphoneMailItem.vue?vue&type=script&setup=true&lang=js"

import "./StudentJenphoneMailItem.vue?vue&type=style&index=0&id=850d3c8c&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-850d3c8c"]])

export default __exports__